module.exports = __webpack_public_path__ + "img/template-bg.66dce694.png";